import { Grid } from '@material-ui/core'
import moment from 'moment'
import React, { useState } from 'react'
import { Field, FormSpy } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import Autocomplete from '../../../components/Autocomplete'
import { CustomTextField } from '../../../components/CustomDisabledFields'
import NumberFormatCustom from '../../../components/NumberFormatCustom'
import { StatusEnum } from '../../Solicitacoes/components'
import { cenarioRepository } from '../CenarioRepository'

const toOptionCenario = cenario => {
  const label = `${cenario.risco?.numero} - ${cenario.descricao}`
  return { id: cenario.id, value: cenario.id, label }
}

const labelFormat = data => {
  if (!Array.isArray(data) && data) {
    return toOptionCenario(data)
  }
}

export const loadCenario = async (
  inputValue,
  idSolicitacao,
  statusSolicitacao
) => {
  const response = await cenarioRepository.listBySolicitacao({
    value: inputValue,
    limit: 10,
    idSolicitacao,
    statusSolicitacao
  })
  if (response.ok) {
    return response.data.map(toOptionCenario)
  }
  return []
}

const Input = props => {
  return (
    <Autocomplete
      repository={cenarioRepository}
      labelOption="descricao"
      labelFormat={labelFormat}
      loadOptions={inputValue =>
        loadCenario(inputValue, props.idSolicitacao, props.statusSolicitacao)
      }
      {...props}
    />
  )
}

function FetchListener({ change, idSolicitacao, statusSolicitacao }) {
  const [consultaAutomatica, setConsultaAutomatica] = useState(true)

  async function fetch() {
    if (!consultaAutomatica) return

    const cenarios = await loadCenario(
      undefined,
      idSolicitacao,
      statusSolicitacao
    )

    const firstCenario = cenarios?.[0]

    if (firstCenario) {
      change('cenarioId', firstCenario.id)
    }

    setConsultaAutomatica(false)
  }

  fetch()

  return null
}

const CenarioBySolicitacaoAutocomplete = props => {
  const idSolicitacao = props.idSolicitacao
  const statusSolicitacao = props.statusSolicitacao

  const isNaoRecomendada = statusSolicitacao === StatusEnum.NAORECOMENDADA

  async function changeNovoLimiteCarga(change, id) {
    const response = await cenarioRepository.getOne({ id })

    if (response.ok) {
      const data = response.data

      if (!isNaoRecomendada) {
        change('novoLimiteCarga', data.limiteValorKmm)
      }

      // A data de validade segue o prazo de renovação do cenário selecionado
      // (inclusive no "Não Recomendar", onde o prazo costuma ser 0 = data atual).
      change(
        'validate',
        moment()
          .add(Number(data.prazoRenovacao) || 0, 'days')
          .toDate()
      )
    }
  }

  return (
    <FormSpy subscription={{ onChange: true }}>
      {({ form: { change }, ...props }) => (
        <Grid container spacing={4}>
          <FetchListener
            change={change}
            idSolicitacao={idSolicitacao}
            statusSolicitacao={statusSolicitacao}
          />
          <Grid item xs={12}>
            <Field
              fullWidth
              name="cenarioId"
              label="Cenário"
              idSolicitacao={idSolicitacao}
              statusSolicitacao={statusSolicitacao}
              component={Input}
              disabled={isNaoRecomendada}
              {...props}
            />
          </Grid>

          {/* Sempre ativo (inclusive no "Não Recomendar") para preencher a
              data de validade pelo prazo de renovação do cenário selecionado. */}
          <OnChange name="cenarioId">
            {value => {
              changeNovoLimiteCarga(change, value)
            }}
          </OnChange>

          {!isNaoRecomendada ? (
            <Grid item xs={12}>
              <Field
                fullWidth
                label="Novo Limite de Carga"
                name="novoLimiteCarga"
                component={CustomTextField}
                disabled
                InputProps={{
                  inputComponent: NumberFormatCustom
                }}
              />
            </Grid>
          ) : (
            undefined
          )}
        </Grid>
      )}
    </FormSpy>
  )
}

export { CenarioBySolicitacaoAutocomplete }
